import React, { FC, useContext } from "react";
import { TenantContext } from "v3/context/tenant";
import { InternalLink } from "@pepdirect/v3/ui/InternalLink";
import { ExternalLink } from "@pepdirect/v3/ui/ExternalLink";
import { getSortedFooterLinks } from "@pepdirect/v3/helpers/footer";
import {
  StyledFooter,
  StyledInnerWrapper,
  StyledLink,
  StyledPipe,
} from "./index.styled";

export const PortalFooter: FC = () => {
  const { tenant } = useContext(TenantContext);

  if (
    typeof window !== "undefined" &&
    window.navigator.userAgent.includes("GxApp")
  ) {
    return null;
  }

  const sortedFooterLinks = getSortedFooterLinks(
    tenant?.brandConfig.customizations.links || [],
    tenant?.domain && `secure.${tenant?.domain}`
  );

  return (
    <StyledFooter data-testid="portal-footer">
      <StyledInnerWrapper>
        {sortedFooterLinks.map((link, index) => {
          return (
            <StyledLink key={`footer-link-${index}`}>
              {!!index && <StyledPipe>|</StyledPipe>}
              {link.isInternal ? (
                <InternalLink href={link.url}>{link.name}</InternalLink>
              ) : (
                <ExternalLink
                  href={link.url}
                  openInSameTab={!link.isOpenNewTab}
                >
                  {link.name}
                </ExternalLink>
              )}
            </StyledLink>
          );
        })}
      </StyledInnerWrapper>
    </StyledFooter>
  );
};
